import cls from 'classnames'
import { h } from 'preact'
import { FIELD_PAGE_SCROLL_WRAPPER_SELECTOR } from 'scripts/constants'
import { ForwardFn, forwardRef } from 'preact/compat'
import styles from './index.scss'

const FieldScrollArea: ForwardFn<{ children: any }, HTMLDivElement> = ({ children }, ref) => {
  return (
    <div className={cls(FIELD_PAGE_SCROLL_WRAPPER_SELECTOR, styles.fieldScrollWrapper)} ref={ref}>
      <div className={styles.fieldScrollContent}>{children}</div>
    </div>
  )
}

export default forwardRef(FieldScrollArea)
